/**
 * ConnectionTracker
 */
import React from 'react';
import { connect } from 'react-redux';

// Actions
import { setIsOnline } from '../../services/connection/actions';

interface Props {
    setIsOnline: Function;
}

export class ConnectionTracker extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { props } = this;
        props.setIsOnline(false);
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.setIsOnline(true);
    }

    render(): null {
        return null;
    }
}

export default connect(
    null,
    { setIsOnline }
)(ConnectionTracker);
